import type { ProductVariant } from "@models/product";
import { isVariantAvailable } from "./_helpers/isVariantAvailable";

interface VariantChipsProps {
    variants: ProductVariant[];
    selectedId: string | undefined;
    onSelect: (variantId: string) => void;
}

export const VariantChips = ({
    variants,
    selectedId,
    onSelect,
}: VariantChipsProps) => {
    if (variants.length === 0) return null;

    return (
        <div
            role="radiogroup"
            aria-label="Product variants"
            className="flex flex-wrap gap-2"
        >
            {variants.map((variant) => {
                const isSelected = variant.id === selectedId;
                const isDisabled = !isVariantAvailable(variant);
                return (
                    <button
                        key={variant.id}
                        type="button"
                        role="radio"
                        aria-checked={isSelected}
                        disabled={isDisabled}
                        onClick={() => onSelect(variant.id)}
                        className={`rounded-full border px-4 py-1 text-sm font-semibold transition-colors ${
                            isSelected
                                ? "border-primary bg-primary text-primary-content"
                                : "border-base-300 bg-base-100 text-neutral hover:border-primary"
                        } disabled:opacity-50 disabled:cursor-not-allowed`}
                    >
                        {variant.name}
                    </button>
                );
            })}
        </div>
    );
};
